import styled from "styled-components/macro";
import { DefaultFont } from "../../../styles/fonts";

export const Root = styled.div`
    @media (max-width: 560px) {
    font-size: 14px;
  }
`;
export const Footer = styled.div`
  margin-top: 16px;
  display: flex;
  justify-content: space-between;


  @media (max-width: 560px) {
    margin-top: 8px;
  }
`;
export const ArrowButton = styled.button`
  border: none;
  background: white;
  border-radius: 8px;
  padding: 0 16px;
  cursor: pointer;

  &:disabled {
    cursor: default;
    svg {
      path {
        fill: ${(p) => p.theme.colors.textMuted};
      }
    }
  }

  svg {
    width: 20px;
    height: auto;

    path {
      fill: ${(p) => p.theme.text.color.blue};
    }
  }
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1),
    0px 4px 6px -2px rgba(0, 0, 0, 0.05);
`;
export const PreviousButton = styled(ArrowButton)``;
export const NextButton = styled(ArrowButton)``;
export const CurrentCardNumber = styled.div`
  background: white;
  ${DefaultFont};
  font-size: 16px;
  padding: 16px 34px;
  border-radius: 8px;
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1),
    0px 4px 6px -2px rgba(0, 0, 0, 0.05);

  @media (max-width: 560px) {
    padding: 4px 34px;
    /* font-size: 14px; */
  }
`;
